<template>

  <div class="hit-html-html">

      <ol class="hit-breadcrumb">
        <li class="hit-html-li" v-for="(breadcrumb, index) in breadcrumbs" v-bind:key="'beadcrumb_'+index" v-bind:class="{ 'hit-active': is_active($route.name, breadcrumb.name) }" >
          <router-link v-if="$route.name != breadcrumb.name" class="hit-html-a" :to="{ name: breadcrumb.name, params: {lang: $store.getters.lang} }">{{ $tc('message.'+breadcrumb.message, 2) }}</router-link>
          <span v-if="$route.name == breadcrumb.name">{{ $tc('message.'+breadcrumb.message, 2) }}</span>
        </li>
      </ol>

      <slot></slot>

  </div>

</template>

<script>

export default{

  data: function () {
    this.$store.commit('update_page_title', 'Dashboard')

    var breadcrumb = [
      {name: 'app', message: 'dashboard', count: false},
      {name: 'profile', message: 'profile', count: false },
      {name: 'boards', message: 'board', count: 'boards' },
      {name: 'feedbacks', message: 'feedback', count: 'votes' },
      {name: 'logout', message: 'logout', count: false }
    ]

    return {
      breadcrumbs: breadcrumb
    }
  },

  methods: {

    get_count: function (name) {
      if (name == false) { return false }

      return Object.keys(this.$store.getters[ name ]).length
    },

    is_active: function (a, b) {
      if (a === b) { return true }
    }
  },
  mounted: function () {

  }

}

</script>

<style>
.fade-enter-active, .fade-leave-active{
	transition: all 0.3s ease-out;

  transform-origin: center right;

}

.fade-enter-active{
	transition-delay: 0.3s;
}

.fade-enter, .fade-leave-to{
	 transform: translateX(-100%) rotateY(-180deg);
   opacity: 0;
}

.fade-leave-to{
  display: none;
}
</style>

<style scoped>
li.hit-active{
  font-weight: bold;
}
</style>
